import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { Link, Typography } from "@mui/material";
// routes
import { PATH_AUTH } from "../../routes/paths";
// components
import Iconify from "../../components/iconify";
// sections
import AuthResetPasswordForm from "../../sections/auth/AuthResetPasswordForm";
// assets
import { PasswordIcon } from "../../assets/icons";

// ----------------------------------------------------------------------

export default function ResetPasswordPage() {
  return (
    <>
      <Helmet>
        <title> Reiniciar contraseña | Parnerus</title>
      </Helmet>

      <PasswordIcon sx={{ mb: 5, height: 96 }} />

      <Typography variant="h3" paragraph>
        ¿Olvidaste tu contraseña?
      </Typography>

      <Typography sx={{ color: "text.secondary", mb: 5 }}>
        Por favor, ingrese su correo asociado a su cuenta y le enviaremos una
        contraseña temporal con la cual podrá acceder a su cuenta y luego
        cambiar su contraseña desde los ajustes.
      </Typography>

      <AuthResetPasswordForm />

      <Link
        component={RouterLink}
        to="/"
        color="inherit"
        variant="subtitle2"
        sx={{
          mt: 3,
          mx: "auto",
          alignItems: "center",
          display: "inline-flex",
        }}
      >
        <Iconify icon="eva:chevron-left-fill" width={16} />
        Ingresar
      </Link>
    </>
  );
}
